import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AutomationsView } from '@/features/automations/AutomationsView.js';
import { ensureAutomationsEnabled } from '@/features/automations/guard.js';

/**
 * Index route for `/scheduled`. The index and `/scheduled/$id` detail routes
 * are siblings under an implicit parent so the detail does not render the list.
 */
export const Route = createFileRoute('/scheduled/')({
  component: ScheduledPage,
  beforeLoad: () => ensureAutomationsEnabled(),
});

function ScheduledPage(): JSX.Element {
  return <AutomationsView />;
}
